export default "__VITE_ASSET__DqL3JG8K__"